import Vue from "vue";
import VueBus from "vue-bus";
import VueClipboard from "vue-clipboard2";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Api from "./assets/api";

import "./assets/style/theme/index.css";
import ElementUI from "element-ui";
import "@/assets/style/common.less";
import VueQriously from "vue-qriously";
import "./assets/icons/index.js";
import "./assets/globallyComponent/index.js";

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import { deepClone } from "@/utils/deepClone";
import { v4 as uuidv4 } from "uuid";

Vue.config.productionTip = false;
Vue.prototype.$Api = Api;
Vue.prototype.$uuidv4 = uuidv4;
Vue.prototype.$deepClone = deepClone;
Vue.prototype.$BASE_URL = process.env.VUE_APP_Base_URL;

Vue.use(VueQriously);
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.use(VueBus);
Vue.use(Viewer);
Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  // toolbar: false,
  fullscreen: false,
  minZoomRatio: 0.1,
  maxZoomRatio: 1.5,
  // zoomRatio: 1,
  // movable: false,
  backdrop: false,
  keyboard: false,
  loop: false,
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
